module.exports = __webpack_public_path__ + "static/media/paper.be9f8667.svg";